/* global angular */

import './style.less';

export default function($log, $q, $stateParams, $scope, $state, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.prev = index => {
    const params = angular.copy($stateParams);
    params.moduleId = vm.course.modules[index - 1];
    $state.go('^.quiz', params);
    $scope.$parent.selfStudyCtrl.activeModule = params.moduleId;
  };

  vm.next = () => {
    return ApiClass.coursesIdTypeTypeIdPatch(
      { id: $stateParams.courseId, type: 'progress', type_id: $stateParams.id },
      { video: true, module_id: $stateParams.moduleId }
    )
      .then(() => {
        if (
          $scope.$parent.selfStudyCtrl &&
          $scope.$parent.selfStudyCtrl.progress &&
          $scope.$parent.selfStudyCtrl.progress.modules
        ) {
          $scope.$parent.selfStudyCtrl.progress.modules[$stateParams.moduleId].video = true;
        }
        $state.go('^.quiz', $stateParams);
        $scope.$parent.selfStudyCtrl.activeModule = $stateParams.moduleId;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Video Component Activated');
    vm.loaded = false;
    vm.error = {};
    ApiClass.coursesIdGet({ id: $stateParams.courseId }, {}, { queryParams: { updateProgress: true } })
      .then(courseResponse => {
        vm.course = courseResponse.data.course;
        vm.index = vm.course.modules.indexOf($stateParams.moduleId);
        vm.video = vm.course.modulesArr[vm.index].video;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selfStudy/video/controller.js